import axios from "axios";
import { defineStore } from "pinia";
export const useSetProductStore =defineStore('setProduct',{
    state:()=>({
        product: [],
        category: [],
        newProduct: [],
        catProduct:[],
        proposal:[],
    }),
        getters:{
            getProduct(state) {
               return state.product;
            },
            getCategory(state) {
               return state.category;
            },
            getNewProduct(state) {
               return state.newProduct;
            },
            getCategoryProduct(state) {
              // catproduct seperate product that are in same category 
               return state.catProduct;
            },
            getProposal(state){
              return state.proposal;
            }
        },
        actions:{
            async setProductFromApi() {
                try {
                  const response = await axios.post("https://parsinekala.com/backend/api/products/");
                  this.product=response.data;
                  // Step 1: Map products and variations to product and sorted newProduct
                  const x = response.data.map((product) => {
                    const variationDates = product.variations.map(variation => new Date(variation.created_at));
                    const maxDate = new Date(Math.max(...variationDates));
                    return { id: product.id, recentDate: maxDate };
                  });

                      // Step 2: Sort by recentDate in descending order
                     const sortedProducts = x.sort((a, b) => b.recentDate - a.recentDate);

                     // Step 3: Set newProduct based on sorted product ids
                     this.newProduct = sortedProducts.map(({ id }) => response.data.find(p => p.id === id));

                     // Step 4: Populate category-related products (catProduct)
                     const uniqueCategories = [...new Set(response.data.map(p => p.category.name))];
            
                     this.catProduct = uniqueCategories.map(categoryName => 
                       response.data.filter(p => p.category.name === categoryName)
                     );

                      // Step 5: Sort categories by product count (descending order)
                      this.catProduct.sort((a, b) => b.length - a.length);
                
                } catch (error) {
                  // console.log(error);
                }
              },

             async setCategoryFromApi() {
                try {
                  const response = await axios.post("https://parsinekala.com/backend/api/categories/");    
                  this.category=response.data;         
                } catch (error) {
                  // console.log(error);
                }
              },
              async setProposalfromApi(){
                try {
                  let response= await axios.post('https://parsinekala.com/backend/blog/blogs/');
                  this.proposal=response.data;
                } catch (error) {
                  // console.log(error);
                }
              }
        }
})